import {BaseApp, DIALOG_FLAG_ANIM_SLIDE} from "./BaseApp";
import {StyledBoxColumn} from "./StyledComponents";
import {PD_LG} from "./dimens";
import {Login} from "./Login";
import {getMemberAuth} from "./auth";
import {Typography} from "@mui/material";

export class LoginHelper {

  static loginAndRun(callback: () => void): void {
    const memberAuth = getMemberAuth();
    if (memberAuth?.auth?.currentUser) {
      callback();
      return null;
    }
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_ANIM_SLIDE},
      () => <StyledBoxColumn style={{padding: PD_LG}}>
        <Typography variant="h6">Login to Continue</Typography>
        <Login/>
      </StyledBoxColumn>)
  }
}